/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { FaCheck } from 'react-icons/fa';

import Modal from '../../../../../components/Modal/Modal';
import { GhostButton, PrimaryButton } from '../../../../../styles/ui/Button';
import {
   formatScheduleDateBr,
   formatSchedulePeriodLabel,
} from './importHelpers';

// ===========================================================================
// ConfirmImportModal — confirmação leve antes do POST /import/confirm. O import
// é escrita em lote (all-or-nothing) e a data/período viram imutáveis após o
// confirm (UNIQUE composto), por isso a dupla confirmação. Sem a contagem
// regressiva do fluxo antigo (decisão 2026-07-08) — o botão Confirmar é azul
// (escrita real, FC7).
// ===========================================================================
export default function ConfirmImportModal({
   isOpen,
   onClose,
   onConfirm,
   isSubmitting = false,
   selectedCount = 0,
   scheduleDate,
   schedulePeriod,
}) {
   const footer = (
      <>
         <GhostButton type="button" onClick={onClose} disabled={isSubmitting}>
            Cancelar
         </GhostButton>
         <PrimaryButton type="button" onClick={onConfirm} disabled={isSubmitting}>
            <FaCheck size={14} />
            {isSubmitting ? 'Importando…' : 'Confirmar importação'}
         </PrimaryButton>
      </>
   );

   return (
      <Modal
         isOpen={isOpen}
         onClose={onClose}
         title="Confirmar importação do roteiro"
         maxWidth="460px"
         footer={footer}
      >
         <p style={{ margin: 0, fontSize: 14, lineHeight: 1.5 }}>
            Inserindo <strong>{selectedCount}</strong>{' '}
            {selectedCount === 1 ? 'pedido' : 'pedidos'} para{' '}
            <strong>{formatScheduleDateBr(scheduleDate)}</strong> no período{' '}
            <strong>{formatSchedulePeriodLabel(schedulePeriod)}</strong>. A data e
            o período não podem ser alterados depois. Confirma?
         </p>
      </Modal>
   );
}

ConfirmImportModal.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   onClose: PropTypes.func.isRequired,
   onConfirm: PropTypes.func.isRequired,
   isSubmitting: PropTypes.bool,
   selectedCount: PropTypes.number,
   scheduleDate: PropTypes.string,
   schedulePeriod: PropTypes.string,
};
